export {
	productEnvToCdnEnv,
	createSrcFromExtension,
	shortenUuid,
	expandUuid,
} from './createSrcFromExtension';
export { getSrcUrl, isTunnelSrc } from './getSrcUrl';
export { getBrowserLocale } from './getBrowserLocale';
export { getResolverContext } from './getResolverContext';
export { getViewContext } from './getViewContext';
export { selectOptimalInvocationResponse } from './tokenComparison';
export { useCDNAuthSignedCookie, shouldUseCDNAuth } from './useCDNAuthSignedCookie';

export const getBrowserTimezone = (): string => {
	return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
